import { AssetSearchView } from '../components/AssetSearchView';
import pageThemeStyles from '../components/menuPageTheme.module.css';
import { useI18n } from '../i18n';

export function SearchPage() {
  const { t } = useI18n();
  const titleId = 'search-page-title';

  return (
    <div
      className={[pageThemeStyles.wrapEmbedded, pageThemeStyles.wrapThemed].join(' ')}
      role="region"
      aria-label={t('header.searchTitle')}
    >
      <div className={[pageThemeStyles.panelEmbedded, pageThemeStyles.browsePage, pageThemeStyles.browsePageWide].join(' ')}>
        <div className={pageThemeStyles.pageHeader}>
          <span id={titleId} className={pageThemeStyles.pageTitle}>
            {t('header.searchTitle')}
          </span>
        </div>
        <AssetSearchView />
      </div>
    </div>
  );
}
